import React, { useRef } from "react";
import Typography from "@mui/material/Typography";
import MUIPopover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import theme from "@theme";
import Draggable from "react-draggable";

function AddContributePopover({
  buttonLabel,
  variant,
  popoverContent,
  buttonProps,
  popoverProps,
  sx,
}) {
  const triggerRef = useRef(null);

  const handlePopoverClose = (popupState) => {
    popupState.close();
  };

  return (
    <PopupState variant="popover">
      {(popupState) => (
        <div>
          <div
            variant={variant}
            {...bindTrigger(popupState)}
            {...buttonProps}
            style={{
              ...sx,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: sx?.backgroundColor || theme.colors.themeColor,
              },
            }}
            ref={triggerRef}
          >
            {buttonLabel.icon}
          </div>
          {/* <Draggable bounds={{ left: -400, top: 50, right: 500, bottom: 300 }}> */}
          <MUIPopover
            {...bindPopover(popupState)}
            {...popoverProps}
            BackdropProps={{
              onClick: (e) => e.stopPropagation(),
            }}
            sx={{ zIndex: 2000 }}
            onClose={() => handlePopoverClose(popupState)}
          >
            <Typography sx={{ p: 2 }}>
              {React.cloneElement(popoverContent, { popupState })}
            </Typography>
          </MUIPopover>
          {/* </Draggable> */}
        </div>
      )}
    </PopupState>
  );
}

export default AddContributePopover;
